import { useAuth } from './AuthContext'
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  isOwner
} from '../utils/permissionUtils'

/**
 * 权限管理 Hook
 * 提供便捷的权限检查方法
 */
export const usePermission = () => {
  const { permissions, businessRole } = useAuth()

  /**
   * 检查单个权限
   * @param {string} permission - 权限点
   * @returns {boolean}
   */
  const can = (permission) => {
    return hasPermission(permissions, permission)
  }

  /**
   * 检查是否拥有任一权限
   * @param {Array<string>} permissionList - 权限列表
   * @returns {boolean}
   */
  const canAny = (permissionList) => {
    return hasAnyPermission(permissions, permissionList)
  }

  /**
   * 检查是否拥有所有权限
   * @param {Array<string>} permissionList - 权限列表
   * @returns {boolean}
   */
  const canAll = (permissionList) => {
    return hasAllPermissions(permissions, permissionList)
  }

  /**
   * 检查是否为拥有者
   * @returns {boolean}
   */
  const isBusinessOwner = () => {
    return isOwner(businessRole)
  }

  return {
    permissions,
    businessRole,
    can,
    canAny,
    canAll,
    isBusinessOwner
  }
}
